import {
  Badge,
  Box,
  Button,
  createStyles,
  Group,
  Select,
  SimpleGrid,
  Table,
  Text,
  TextInput,
  ComboBox,
  Paper,
} from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";
import React, { useCallback, useEffect, useState } from "react";
import { getProviderServices } from "../../services/servicecode";
import { useSelector } from "react-redux";
import { IconChevronDown } from "@tabler/icons-react";
import TableLoader from "../TableLoader";
import { debounce, showError } from "../../utils";
import store from "../../store";
import { setAllProviderServices } from "../../store/reducers/servicecode";

import ProviderServicesLookupModal from "./providerServicesLookupModal";
import swal from "sweetalert";

const useStyles = createStyles(() => ({
  container: {
    // padding: "12px 12px 20px 30px",
    padding: "5px 0px 10px 0px",
    borderRadius: "12px",
    // border: "1px solid #E5E5EA",
    background: "#FFF",
  },
  searchInputParent: {
    width: "100%",
    margin: "20px auto",
  },

  searchInput: {
    height: "50px",
    // borderRadius: "25px",
  },

  bg1: {
    "& td": {
      background: "#fff",
    },
  },
  bg2: {
    "& td": {
      background: "#F9FAFB",
    },
  },

  header: {
    fontFamily: "Inter !important",
    fontSize: "14px !important",
    fontWeight: "700 !important",
    color: "#000 !important",
  },

  specialtextInputBox: {
    width: "140px",
    maxWidth: "fit-content",
    margin: "auto",
    padding: "5px 11px",
    backgroundColor: bgColor,
    borderRadius: "8px",
    border: "1px solid #E5E5E5",
    "& input": {
      border: "none",
      paddingInline: 0,
      backgroundColor: "transparent",
    },
  },

  row: {
    fontFamily: "Inter !important",
    fontSize: "14px !important",
    fontWeight: "400 !important",
    color: "#000 !important",
  },

  lookupflex: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },

  newinputbox: {
    background: "#FFF !important",
    border: "1px solid #E5E5E5 !important",
    borderRadius: "8px !important",
    width: "79px !important",
    fontFamily: "Inter !important",
    fontSize: "14px !important",
    fontWeight: "400 !important",
    color: "#000 !important",
    textAlign: "center !important",
    alignItems: "center",

    ".mantine-1vlckrq": {
      textAlign: "center",
      fontFamily: "Inter !important",
      fontSize: "14px !important",
      fontWeight: "400 !important",
      color: "#000 !important",
    },
    ".mantine-6kqrk6": {
      textAlign: "center",
    },
  },

  searchclass: {
    width: "100%",
    borderRadius: "8px",
    border: "1px solid  #D0D5DD",
    background: "#FFF",
    padding: "10px 14px",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    marginBottom: "24px",
  },

  boxnumber: {
    display: "flex",
    flexDirection: "row",
    marginTop: "6px",
    justifyContent: "space-between",
    width: "100%",
  },

  width: {
    width: "45%",
  },

  // searchResultListWrapper: {
  //   maxHeight: "350px",
  //   overflowY: "auto",
  //   marginTop: "16px",
  //   borderRadius: "8px",
  //   border: "1px solid #E5E5E5",
  //   background: "#FFF",
  //   padding: "12px 0px",
  // },

  // searchResultList: {
  //   width: "100%",
  //   margin: "0 auto",
  //   borderCollapse: "collapse",
  //   tableLayout: "fixed",

  //   "& thead": {
  //     position: "sticky",
  //     top: 0,
  //     backgroundColor: "#fff",
  //     zIndex: 1,
  //   },

  //   "& tbody tr:nth-of-type(odd)": {
  //     backgroundColor: "#f1f1f1",
  //   },

  //   "& tbody tr": {
  //     td: {
  //       width: "18.33%",
  //       borderTop: "1px solid #868e96",
  //       padding: "10px 20px",
  //       fontSize: "15px",
  //       "& button": {
  //         padding: "0px",
  //         backgroundColor: "transparent",
  //         border: "none",
  //         cursor: "pointer",
  //         fontWeight: "700",
  //       },
  //     },
  //     // "& td:nth-of-type(1)": {
  //     //   width: "30%",
  //     // },
  //   },
  //   "& thead th": {
  //     fontWeight: 700,
  //     color: "#000",
  //     fontSize: "14px",
  //     textAlign: "start",
  //     padding: "16px 20px",
  //     // width: "18.33%",
  //   },

  //   "& thead th:nth-child(1)": {
  //     width: "21%",
  //   },
  //   "& thead th:nth-child(3)": {
  //     width: "22%",
  //   },

  //   "& thead th:nth-child(4)": {
  //     width: "12%",
  //   },

  //   center: {
  //     display: "flex",
  //     justifyContent: "center",
  //     width: "100%",
  //   },

  //   // "& thead th:nth-child(4)": {
  //   //   width: "10%",
  //   // },
  // },
}));

const bgColor = "#FFFFFF";

const CustomTextInput = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "10px 14px",
      borderRadius: "8px",
      height: "44px",
      border: "1px solid #E5E5E5",
      backgroundColor: bgColor,
      "& input": {
        backgroundColor: "transparent",
        border: "none",
        paddingInline: 0,
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <TextInput {...rest} />
    </div>
  );
};

const CustomSelectBox = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "5px 11px",
      backgroundColor: bgColor,
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      "& input": {
        border: "none",
        paddingInline: 0,
        backgroundColor: "transparent",
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <Select
        {...rest}
        rightSection={<IconChevronDown color={"#000"} size={20} />}
        rightSectionWidth={25}
        styles={{ rightSection: { pointerEvents: "none" } }}
      />
    </div>
  );
};

function ProviderServiceSearch({
  existingServices,
  setExistingServices,
  setActiveService,
  activeService,
  isEditMode,
  setIsEditMode,
}) {
  const { classes } = useStyles();
  const allproviderservices = useSelector(
    (state) => state?.servicecode?.allproviderservices?.allproviderservices
  );
  // console.log("allproviderservices", allproviderservices);

  // console.log("isEditMode", isEditMode);

  // console.log("isEditMode", isEditMode);

  const [providerservices, setProviderServices] = useState({
    servicetitle: "",
    servicenumber: "",
    servicechargetype: "",
    // servicechargeNumber: "",
    // servicerate:"",
  });
  const [openlookup, setOpenLookup] = useState(false);
  const [services, setServices] = useState([]);

  // console.log("services", services);

  const [search, setSearch] = useState("");

  const { loading } = useSelector((state) => state?.servicecode);

  console.log('allproviderservices',allproviderservices);
  

  const debouncedSearch = useCallback(
    debounce((value) => {
      value && getProviderServices(value);
    }, 700),
    []
  );

  useEffect(() => {
    !search?.trim() && store.dispatch(setAllProviderServices([]));
  }, [search]);

  useEffect(() => {
    getProviderServices("all");
  }, []);

  const handleAddService = (selectedOption) => {
    console.log("selectedOption", selectedOption);
    console.log("allproviderservices", allproviderservices);

    // console.log('selectedOption',selectedOption);
    if (selectedOption) {
      const selectedService = allproviderservices.find(
        (service) =>
          service.name === selectedOption.name &&
          service.code === selectedOption.code
      );

      if (selectedService) {
        setProviderServices({
          servicetitle: selectedService.name,
          servicenumber: selectedService.code,
          servicechargetype: selectedService.servicechargetype,
          // servicechargeNumber: selectedService.servicechargeNumber,
        });
      }
    } else {
      setProviderServices({
        servicetitle: "",
        servicenumber: "",
        servicechargetype: "",
        // servicechargeNumber: "",
        servicerate: "",
      });
    }
  };

  const handleService = () => {
    const newService = {
      servicetitle: providerservices.servicetitle,
      servicenumber: providerservices.servicenumber,
      servicechargetype: providerservices.servicechargetype,
      // servicechargeNumber: providerservices.servicechargeNumber,
      servicerate: providerservices.servicerate,
    };

    //  setServices((prevServices) => [...prevServices, newService]);
    setExistingServices([...existingServices, newService]);

    setProviderServices({
      servicetitle: "",
      servicenumber: "",
      servicechargetype: "",
      // servicechargeNumber: "",
      servicerate: "",
    });
    setSearch("");
  };

  // console.log("search", search);

  const handleSearchChange = (value) => {
    console.log("value", value);

    setSearch(value);
    debouncedSearch(value);
  };

  const handleServiceCostChange = (name, value) => {
    setProviderServices({
      ...providerservices,
      [name]: value,
    });
  };

  // console.log("+++++++++++++++++++", existingServices, isEditMode);

  return (
    <Box className={classes.container}>
      <Select
        style={{
          borderRadius: "8px",
          background: "#FFF",
          marginBottom: "24px",
        }}
        value={providerservices.name}
        rightSection={
          <IconChevronDown display={"none"} color={"#000"} size={20} />
        }
        onChange={(selectedOption) => handleAddService(selectedOption)}
        onSearchChange={(value) => {
          setSearch(value); // <- Store input in local state
          debouncedSearch(value); // <- Trigger debounced search
        }}
        searchable
        limit={10}
        data={
          allproviderservices?.map((item) => ({
            value: item,
            // label: item?.name  ||"Not Found",
            label: `${item.code} - ${item.name}`
          })) || []
        }
        icon={<IconSearch size={20} color="#737373" />}
        placeholder="Search service # or Service Title"
      />

      <Box className={classes.addbox}>
        <Group className={classes.boxnumber}>
          <Box className={classes.width}>
            <Text ff={"Inter"} fz={14} fw={500} color="#344054">
              Service Title
            </Text>
            <CustomTextInput
              name="servicetitle"
              value={providerservices.servicetitle}
              // value={knownIllnessField?.servicetitle}
              // onChange={handleChange}
              // onChange={(e, option) => handleChange(e, option)}
              onChange={(e) =>
                handleServiceCostChange("servicetitle", e.target.value)
              }
              size="sm"
              // disabled={true}
              //  readOnly
            />
          </Box>

          <Box className={classes.width}>
            <Text ff={"Inter"} fz={14} fw={500} color="#344054">
              Service Code
            </Text>
            <CustomTextInput
              name="servicenumber"
              value={providerservices.servicenumber}
              // value={knownIllnessField?.servicenumber}
              // onChange={handleChange}
              //onChange={(e, option) => handleChange(e, option)}
              onChange={(e) =>
                handleServiceCostChange("servicenumber", e.target.value)
              }
              // disabled={true}
              // readOnly
              size="sm"
            />
          </Box>
        </Group>

        <Group className={classes.boxnumber}>
          <Box className={classes.width}>
            <Text ff={"Inter"} fz={14} fw={500} color="#344054">
              Service Unit
            </Text>
            <Box className={classes.boxnumber}>
              <CustomSelectBox
                //  value={knownIllnessField.servicechargetype}
                //  onChange={handleChange}
                // onChange={(e, option) => handleChange(e, option)}
                // onChange={(value) =>
                //   handleChange("servicechargetype", value)
                // }
                placeholder={"Unit"}
                value={providerservices.servicechargetype}
                withAsterisk
                data={[
                  { value: "unit", label: "1 Unit" },
                  { value: "hour", label: "1 Hour" },
                  { value: "day", label: "1 Day" },
                  { value: "month", label: "1 Month" },
                  { value: "15", label: "15 Minutes" },
                  { value: "30", label: "30 Minutes" },
                  { value: "45", label: "45 Minutes" },
                ]}
                onChange={(value) =>
                  handleServiceCostChange("servicechargetype", value)
                }

                //   {...form.getInputProps("servicechargetype")}
              />
            </Box>
          </Box>
        </Group>

        <Box
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "24px",
            marginBottom: "48px",
          }}
        >
          <Button
            type="button"
            c={"#FFF"}
            onClick={handleService}
            variant="fixed"
            bg={"black"}
            size="sm"
            w={"100%"}
          >
            + Add
          </Button>
        </Box>

        {loading ? (
          <TableLoader />
        ) : (
          (existingServices?.length > 0 ||
            (isEditMode && existingServices?.length > 0)) && (
            <Paper
              sx={{
                borderRadius: "8px !important",
                border: "1px solid #E5E5E5",
              }}
              withBorder
            >
              <Table
                highlightOnHover={true}
                enableStickyHeader={true}
                sx={{
                  fontFamily: "Inter",
                  // borderRadius: "8px !important",
                  // border: "1px solid #E5E5E5",
                }}
                fontSize={"sm"}
                verticalSpacing={"md"}
              >
                <thead className={classes.tableHead}>
                  <tr>
                    <th className={classes.header}>Service Name</th>
                    <th className={classes.header}>Code</th>
                    <th
                      style={{ textAlign: "center" }}
                      className={classes.header}
                    >
                      Unit Type
                    </th>
                    {/* <th className={classes.header}>Amount</th> */}
                    {/* <th className={classes.header}>Rate</th> */}
                    <th className={classes.header}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {existingServices?.length > 0 &&
                    existingServices?.map((existingService, index) => {
                      // console.log("existingService", existingService);

                      const bg = index % 2 === 0 ? classes.bg2 : classes.bg1;

                      return (
                        <tr key={index} className={bg}>
                          <td
                            style={{ width: "24%", maxWidth: "fit-content" }}
                            className={classes.row}
                          >
                            {existingService?.servicetitle}
                          </td>
                          <td className={classes.row}>
                            {existingService?.servicenumber}
                          </td>

                          <td className={classes.row}>
                            <Select
                              className={classes.specialtextInputBox}
                              rightSection={
                                <IconChevronDown color={"#000"} size={20} />
                              }
                              rightSectionWidth={25}
                              styles={{
                                rightSection: { pointerEvents: "none" },
                              }}
                              value={
                                existingService?.servicechargetype || "unit"
                              } // Default value (unit) if undefined
                              onChange={(value) => {
                                // Update the existingServices state with the selected value
                                setExistingServices((prevState) =>
                                  prevState.map((service) =>
                                    service?.servicetitle ===
                                      existingService?.servicetitle &&
                                    service?.servicenumber ===
                                      existingService?.servicenumber
                                      ? { ...service, servicechargetype: value }
                                      : service
                                  )
                                );
                              }}
                              data={[
                                { value: "unit", label: "1 Unit" },
                                { value: "hour", label: "1 Hour" },
                                { value: "day", label: "1 Day" },
                                { value: "month", label: "1 Month" },
                                { value: "15", label: "15 Minutes" },
                                { value: "30", label: "30 Minutes" },
                                { value: "45", label: "45 Minutes" },
                              ]}
                            />
                          </td>

                          <td>
                            <Button
                              variant="subtle"
                              color="red"
                              bg={"#FEF3F2"}
                              onClick={async () => {
                                const willDelete = await swal({
                                  title: `Are you sure you want to delete this service?`,
                                  text: "This Service Is Used By Other Client",
                                  icon: "warning",
                                  dangerMode: true,
                                  buttons: ["Cancel", "Delete"],
                                });

                                if (willDelete) {
                                  let temp = existingServices?.filter(
                                    (_, i) => i !== index
                                  );
                                  setExistingServices(temp);
                                } // Remove service at index
                              }}
                            >
                              Remove
                            </Button>
                          </td>
                        </tr>
                      );
                    })}

                  {services
                    ?.filter((service) =>
                      isEditMode
                        ? !existingServices.some(
                            (existingService) =>
                              service?.code === existingService?.servicenumber
                          )
                        : true
                    )
                    ?.map((service) => (
                      <tr key={service?._id}>
                        <td>{service?.servicetitle}</td>
                        <td>{service?.servicenumber}</td>

                        {existingServices?.some(
                          (existService) => existService?._id === service?._id
                        ) ? (
                          <td>
                            <Button
                              variant="subtle"
                              color="red"
                              onClick={async () => {
                                const willDelete = await swal({
                                  title: `Are you sure you want to delete this service?`,
                                  text: "This Service Is Used By Other Client",
                                  icon: "warning",
                                  dangerMode: true,
                                  buttons: ["Cancel", "Delete"],
                                });

                                if (willDelete) {
                                  let temp = existingServices?.filter(
                                    (existService) =>
                                      existService?._id !== service?._id
                                  );
                                  setExistingServices(temp);
                                } // Remove service
                              }}
                            >
                              Remove
                            </Button>
                          </td>
                        ) : (
                          <>
                            <td>
                              <Select
                                disabled={true}
                                defaultValue={"1unit"}
                                value={service?.servicechargetype}
                                rightSection={
                                  <IconChevronDown
                                    color={"#FBAA0D"}
                                    size={20}
                                  />
                                }
                                styles={{
                                  rightSection: { pointerEvents: "none" },
                                }}
                                onChange={(value) =>
                                  setActiveService((prevState) => {
                                    return {
                                      ...prevState,
                                      _id: service?._id,
                                      servicetitle: service?.name,
                                      servicenumber: service?.code,
                                      servicechargetype: value,
                                    };
                                  })
                                }
                                placeholder={"Unit"}
                                data={[
                                  { value: "unit", label: "1 Unit" },
                                  { value: "hour", label: "1 Hour" },
                                  { value: "day", label: "1 Day" },
                                  { value: "month", label: "1 Month" },
                                ]}
                              />
                            </td>

                            <td>
                              <Button
                                variant="subtle"
                                color="red"
                                onClick={async () => {
                                  const willDelete = await swal({
                                    title: `Are you sure you want to delete this service?`,
                                    text: "This Service Is Used By Other Client",
                                    icon: "warning",
                                    dangerMode: true,
                                    buttons: ["Cancel", "Delete"],
                                  });

                                  if (willDelete) {
                                    let temp = services?.filter(
                                      (existService) =>
                                        existService?.servicetitle !==
                                        service?.servicetitle
                                    );
                                    setServices(temp);
                                  }
                                }}
                              >
                                Remove
                              </Button>
                            </td>
                          </>
                        )}
                      </tr>
                    ))}
                </tbody>
              </Table>
            </Paper>
          )
        )}
      </Box>

      <ProviderServicesLookupModal
        openlookup={openlookup}
        setOpenLookup={setOpenLookup}
        setProviderServices={setProviderServices}
      />
    </Box>
  );
}

export default ProviderServiceSearch;
